
// Get the navbar
const navbar = document.getElementById("NavStandard");
//Get the announcement bar
const announcementBar = document.querySelector(".announcement-bar-static");
// Get the offset position of the navbar
const sticky = navbar.offsetTop;

// When the user scrolls the page, execute stickyFunction
window.onscroll = function() {
	stickyFunction()
};

// Add the sticky class to the announcement bar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickyFunction() {
	if (window.pageYOffset > sticky) {
		announcementBar.classList.add("announcement-bar-sticky")
	} else {
		announcementBar.classList.remove("announcement-bar-sticky");
	}
}